import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SkillService {

  skills:any[] = [
    {
      skill: 'NODEJS',
      progress: '80',
    },
    {
      skill: 'NESTJS',
      progress: '45',
    },
    {
      skill: 'SQL SERVER',
      progress: '80',
    },
    {
      skill: 'MYSQL',
      progress: '80',
    },
    {
      skill: 'ANGULAR',
      progress: '50',
    },
    {
      skill: 'TYPESCRIPT',
      progress: '70',
    },
    {
      skill: 'JAVASCRIPT',
      progress: '80',
    },
    {
      skill: 'GIT',
      progress: '90',
    },
    {
      skill: 'CSS',
      progress: '90',
    },
    {
      skill: 'HTML',
      progress: '90',
    },
  ]

  constructor() { }
}
